import { i18nInstance } from '@staccx/i18n'

export const getContactErrorMessage = (err) => {
  if (err.response && err.response.data) {
    if (err.response.data.code) {
      const translated = i18nInstance.translate(err.response.data.code)
      // If translation fails and returns "Missing entry", return a generic message
      if (translated && !translated.includes('Missing entry')) {
        return translated
      }
      // Fallback for known error codes
      if (err.response.data.code === 'DUPLICATE_PHONE_NO') {
        return 'Telefonnummeret er allerede i bruk'
      }
      // Generic fallback
      return `Feil: ${err.response.data.code}`
    }
  }
  return err.message
}
